import apiClient from "../../utils/apiClient";
import apiService from "../apiService/apiService";

const GET_COMMUNITY = "/get-community";
const GET_MASTER_CLASS_DISCUSSIONS = "/community/master-class/discussions";
const GET_GENERAL_DISCUSSION = "/get-general-community";
const ADD_GENERAL_POST = "/add-general-post";
const ADD_DISCUSSION = "add-discussion";
const GET_ALL_KEYNOTES = "/get-all-keynotes";
const GET_GENERAL_DISCUSSIONS_BY_ID = "/get-general-discussion";
const EDIT_GENERAL_DISCUSSIONS = "/edit-general-discussion";
const DELETE_GENERAL_DISCUSSIONS = "/delete-general-discussion";

const getCommunity = (page, limit, selectedKeyNote) => {
    let url = `${GET_COMMUNITY}?limit=${limit}&page=${page}&keynoteId=${selectedKeyNote}`;
    return apiClient.get(url);
};

const getGeneralDiscussion = (page, limit, categoryId) => {
    const requestParams = new URLSearchParams();

    requestParams.append('limit', limit);
    requestParams.append('page', page);

    if (categoryId !== null && categoryId !== undefined) {
        requestParams.append('category_id', categoryId);
    }

    const queryString = requestParams.toString();

    let url = `${GET_GENERAL_DISCUSSION}${queryString ? '?' + queryString : ''}`;
    return apiClient.get(url);
};

const getAllKeyNoteList = () => {
    const url = `${GET_ALL_KEYNOTES}`;
    return apiClient.get(url);
};

const addGeneralPost = (data) => {
    const url = `${ADD_GENERAL_POST}`;
    return apiClient.post(url, data);
};

const addDiscussion = (data) => {
    const url = `${ADD_DISCUSSION}`;
    return apiClient.post(url, data);
};

const getGeneralDiscussionById = (id) => {
    const url = `${GET_GENERAL_DISCUSSIONS_BY_ID}/${id}`;
    return apiClient.get(url);
};

const editgeneralDiscussion = (data) => {
    const url = `${EDIT_GENERAL_DISCUSSIONS}`;
    return apiClient.post(url, data);
};

const deleteGeneralDiscussion = (id) => {
    const data = {
        general_community_discussion_id: id,
    };
    const url = `${DELETE_GENERAL_DISCUSSIONS}`;
    return apiClient.post(url, data);
};

const getMasterClassDiscussions = (perPage, page, searchTerm) => {
    const params = {
        'perPage': perPage,
        's': searchTerm,
        'page': page
    };

    const queryString = apiService.getRequestParams(params);

    let url = `${GET_MASTER_CLASS_DISCUSSIONS}${queryString ? '?' + queryString : ''}`;

    return apiClient.get(url);
};

const getMasterClassDiscussionDetails = (id) => {
    let url = `${GET_MASTER_CLASS_DISCUSSIONS}/${id}`;
    return apiClient.get(url);
};

const getCommunityQuestions = (perPage, page, searchTerm) => {
    const params = {
        'perPage': perPage,
        's': searchTerm,
        'page': page
    };

    const queryString = apiService.getRequestParams(params);

    let url = `/community/community-questions${queryString ? '?' + queryString : ''}`;

    return apiClient.get(url);
};

const getMemberDiscussions = (perPage, page, searchTerm) => {
    const params = {
        'perPage': perPage,
        's': searchTerm,
        'page': page
    };

    const queryString = apiService.getRequestParams(params);

    let url = `/community/member-discussions${queryString ? '?' + queryString : ''}`;

    return apiClient.get(url);
};

const getMemberDiscussionsDetails = (id) => {
    let url = `/community/member-discussions/${id}`;
    return apiClient.get(url);
};

const createMemberDiscussion = (data) => {
    const url = `/community/member-discussions`;
    return apiClient.post(url, data);
};

const updateMemberDiscussion = (data, memberDiscussionId) => {
    const url = `/community/member-discussions/${memberDiscussionId}`;
    return apiClient.put(url, data);
};

const deleteMemberDiscussion = (memberDiscussionId) => {
    const url = `/community/member-discussions/${memberDiscussionId}`;
    return apiClient.delete(url);
};

const getCommunityQuestionDetails = (id) => {
    let url = `/community/community-questions/${id}`;
    return apiClient.get(url);
};

const communitySearch = (searchTerm) => {
    const params = {
        's': searchTerm
    };

    const queryString = apiService.getRequestParams(params);

    return apiClient.get(`/community/search${queryString ? '?' + queryString : ''}`)
};

const getGeneralDiscussions = (categoryId, perPage, page, searchTerm) => {
    const params = {
        'perPage': perPage,
        's': searchTerm,
        'page': page
    };

    const queryString = apiService.getRequestParams(params);

    let url = `/community/discussion-categories/${categoryId}/discussions${queryString ? '?' + queryString : ''}`;

    return apiClient.get(url);
};

const getGeneralDiscussionDetails = (categoryId, id) => {
    let url = `/community/discussion-categories/${categoryId}/discussions/${id}`;
    return apiClient.get(url);
};

const updateGeneralDiscussion = (data, categoryId, id) => {
    const url = `/community/discussion-categories/${categoryId}/discussions/${id}`;
    return apiClient.put(url, data);
};

const deleteGeneralCommunityDiscussion = (categoryId, id) => {
    const url = `/community/discussion-categories/${categoryId}/discussions/${id}`;
    return apiClient.delete(url);
};

const likeMasterClass = (masterClassId) => {
    const url = `/community/master-class/discussions/${masterClassId}/like`;
    return apiClient.post(url);
}

const likeMemberDiscussion = (discussionId) => {
    const url = `/community/member-discussions/${discussionId}/like`;
    return apiClient.post(url);
}

const likeCommunityDiscussion = (discussionId) => {
    const url = `/community/community-questions/${discussionId}/like`;
    return apiClient.post(url);
}

const helpRequestMessage = (data) => {
    return apiClient.post('/help', data);
}

const confirmGuidelinesWatching = () => {
    return apiClient.post("/watch-community-guidelines");
};

export const communityService = {
    getCommunity,
    getGeneralDiscussion,
    addGeneralPost,
    addDiscussion,
    getAllKeyNoteList,
    getGeneralDiscussionById,
    editgeneralDiscussion,
    deleteGeneralDiscussion,
    getMasterClassDiscussions,
    getMasterClassDiscussionDetails,
    getCommunityQuestions,
    getCommunityQuestionDetails,
    communitySearch,
    getMemberDiscussions,
    getMemberDiscussionsDetails,
    createMemberDiscussion,
    updateMemberDiscussion,
    getGeneralDiscussions,
    getGeneralDiscussionDetails,
    updateGeneralDiscussion,
    deleteGeneralCommunityDiscussion,
    deleteMemberDiscussion,
    likeMasterClass,
    likeMemberDiscussion,
    likeCommunityDiscussion,
    helpRequestMessage,
    confirmGuidelinesWatching
};
